__turbopack_context__.v({
  "triggerFullWidth": "tooltip-module-scss-module__j6ei4G__triggerFullWidth",
});
